import { COLOR_BASE_GREY_15 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledEquipmentItemWrapper = styled.li`
	position: relative;
	display: flex;
	flex-direction: column;
	column-gap: 24px;
	row-gap: 8px;
	border-bottom: 1px solid ${COLOR_BASE_GREY_15};
	padding-top: 16px;
	padding-bottom: 16px;

	${breakPoints({
		'768': `
			flex-direction: row;
		`,
	})}

	&:last-child {
		border-bottom: 0;
	}

	button {
		align-self: flex-start;
	}
`;

export const StyledImageTeaser = styled.div`
	aspect-ratio: 16 / 9;
	width: 100%;
	flex-shrink: 0;

	${breakPoints({
		'768': `
			width: 208px;
		`,
	})}

	> img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
`;

export const StyledStandAloneImageTeaser = styled(StyledImageTeaser)`
	object-fit: cover;
`;
